<template>
<div class="canvas-wrap">
	<div class="header">
		<div class="title">剧本评估</div>
		<div class="score">
			<div class="level">
				<span>·评级：</span><span class="red-bold">{{scoreDetail&&scoreDetail.level}}</span>
			</div>
			<div class="score-num">
				<span>·总分(0-140)：</span><span class="red-bold">{{scoreDetail&&scoreDetail.score}}分</span>
			</div>
		</div>
	</div>
	<div class="canvas-box">
		<canvas id="canvas">
			您的浏览器不支持CANVAS,请更换浏览器重试。
		</canvas>
	</div>
	<router-link :to="{name:'tvscoredetail',query:{id:this.$route.query.id,type:this.$route.query.type}}"><div class="to-detail" v-if="!detail"><span>查看详情</span></div></router-link>
</div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
export default {
	name:'TvScore',
	props:['detail'],
	data(){
		return{
			CANVAS_WIDTH:'',
			CANVAS_HEIGHT:'',
			scoreNumItem:'',                    //评分分数
			totalScore:'',                      //总分
			totalLevel:'',                      //总评级
			scoreDetail:'',                     //评分总信息
			dpr:'',
			mapR:''
		}
	},
	created(){
		//获取评估详情数据
		Axios.get('article/assess',{params:{type:Number(this.$route.query.type),id:Number(this.$route.query.id)}}).then(
			response=>{
				if(response.data.code==200&&response.data.status=="success"){
					this.scoreDetail=response.data.data
					this.scoreNumItem=JSON.parse(response.data.data.item)
					this.totalScore=response.data.data.score
					this.totalLevel=response.data.data.level
					this.draw()
				}
			},
			error=>{
				console.log(error)
			}
		)
	},
	mounted(){
		this.dpr = window.devicePixelRatio; 
		this.CANVAS_WIDTH=document.querySelector('.canvas-box').getBoundingClientRect().width
		this.CANVAS_HEIGHT=document.querySelector('.canvas-box').getBoundingClientRect().height
		canvas.width=this.CANVAS_WIDTH
		canvas.height=this.CANVAS_HEIGHT
	},
	methods:{
		draw(){
			let canvas=document.querySelector('#canvas');
			let ctx=canvas.getContext('2d');
			ctx.scale(this.dpr,this.dpr);
			ctx.lineWidth=1;
			ctx.globalCompositeOperation="source-over";

			let rangeNum=[0,5,10,15,20];
			// let ScoreDetailItem=[
			// 	'格式(0-20)：',
			// 	'题材创意、故',
			// 	'情节推理、逻',
			// 	'影视作品转化效果(0-20)：',
			// 	'人物设定、塑造(0-20)：',
			// 	'七三三规律完',
			// 	'世界观、价'
			// ];
			let ScoreDetailItem=[
				'格式(0-20)：',
				'题材创意、故',
				'人物设定、塑',
				'情节推动、逻辑性(0-20)：',
				'七三三规律完成度:',
				'影视作品转化',
				'世界观、价'
			];
			let scoreNumArr=[];
			scoreNumArr[0]=this.scoreNumItem['format_score']
			scoreNumArr[1]=this.scoreNumItem['idea_score']
			scoreNumArr[2]=this.scoreNumItem['character_score']
			scoreNumArr[3]=this.scoreNumItem['plot_score']
			scoreNumArr[4]=this.scoreNumItem['rule_score']
			scoreNumArr[5]=this.scoreNumItem['transform_score']
			scoreNumArr[6]=this.scoreNumItem['view_score']
			
			canvas.style.width = canvas.width + 'px';
        	canvas.style.height = canvas.height + 'px';
     
        	canvas.width = this.dpr * this.CANVAS_WIDTH;
			canvas.height = this.dpr * this.CANVAS_HEIGHT;
			
			//多边形半径
			this.mapR=canvas.width/2-140;
			
			//依次绘制评分模型七边形图
			for(let i=0;i<4;i++){
				ctx.beginPath();
				ctx.strokeStyle="#ccc";
				if((i+1)%2===0) {
					ctx.fillStyle="#F7F6F9";
				}else{
					ctx.fillStyle="#fff";
					
				}
				this.drawFilmMap(ctx,this.mapR-i*this.mapR/4);
				ctx.closePath();
				ctx.fill();
				ctx.stroke();
			}

			//绘制中心点散发虚线
			ctx.beginPath();
			ctx.strokeStyle="#ccc";
			this.drawDashLine(ctx,this.mapR);
			ctx.stroke();
			ctx.closePath();

			//添加评分盘内部数字分值文字
			ctx.beginPath();
			ctx.fillStyle="#D24E06";
			ctx.font="bold 16px Arial";
			ctx.textAlign="left";
			for(let i=0;i<5;i++){
				ctx.fillText(rangeNum[i],canvas.width/2+10,(canvas.height/2-this.mapR/4*i)+10)
			}
			ctx.fill();
			ctx.closePath();

			//外圈评分副标题文字
			ctx.fillStyle="#333";
			ctx.font="normal 20px 微软雅黑";
			ctx.textAlign="left";
			ctx.fillText(ScoreDetailItem[0],(Math.sin((0*360/7)/180*Math.PI))*this.mapR+canvas.width/2-50,-(Math.cos((0*360/7)/180*Math.PI))*this.mapR+canvas.height/2-20);
			ctx.fillText(ScoreDetailItem[1],(Math.sin((1*360/7)/180*Math.PI))*this.mapR+canvas.width/2+10,-(Math.cos((1*360/7)/180*Math.PI))*this.mapR+canvas.height/2);
			ctx.fillText('事性(0-20):',(Math.sin((1*360/7)/180*Math.PI))*this.mapR+canvas.width/2+10,-(Math.cos((1*360/7)/180*Math.PI))*this.mapR+canvas.height/2+20);
			ctx.fillText(ScoreDetailItem[2],(Math.sin((2*360/7)/180*Math.PI))*this.mapR+canvas.width/2+2,-(Math.cos((2*360/7)/180*Math.PI))*this.mapR+canvas.height/2);
			ctx.fillText('造(0-20):',(Math.sin((2*360/7)/180*Math.PI))*this.mapR+canvas.width/2+2,-(Math.cos((2*360/7)/180*Math.PI))*this.mapR+canvas.height/2+20);
			ctx.fillText(ScoreDetailItem[3],(Math.sin((3*360/7)/180*Math.PI))*this.mapR+canvas.width/2-30,-(Math.cos((3*360/7)/180*Math.PI))*this.mapR+canvas.height/2+20);
			ctx.fillText(ScoreDetailItem[4],(Math.sin((4*360/7)/180*Math.PI))*this.mapR+canvas.width/2-190,-(Math.cos((4*360/7)/180*Math.PI))*this.mapR+canvas.height/2+20);
			ctx.fillText(ScoreDetailItem[5],(Math.sin((5*360/7)/180*Math.PI))*this.mapR+canvas.width/2-124,-(Math.cos((5*360/7)/180*Math.PI))*this.mapR+canvas.height/2-10);
			ctx.fillText('效果(0-20):',(Math.sin((5*360/7)/180*Math.PI))*this.mapR+canvas.width/2-124,-(Math.cos((5*360/7)/180*Math.PI))*this.mapR+canvas.height/2+10);
			ctx.fillText(ScoreDetailItem[6],(Math.sin((6*360/7)/180*Math.PI))*this.mapR+canvas.width/2-134,-(Math.cos((6*360/7)/180*Math.PI))*this.mapR+canvas.height/2-10);
			ctx.fillText('值观(0-20):',(Math.sin((6*360/7)/180*Math.PI))*this.mapR+canvas.width/2-134,-(Math.cos((6*360/7)/180*Math.PI))*this.mapR+canvas.height/2+20-10);
			
			//外圈评分分数数字
			ctx.fillStyle="#D24E06";
			ctx.font="bold 20px Arial";
			ctx.textAlign="left";
			ctx.fillText(this.scoreNumItem['format_score'],(Math.sin((0+0*360/7)/180*Math.PI))*this.mapR+canvas.width/2+ctx.measureText(ScoreDetailItem[0]).width/2+6,-(Math.cos((0+0*360/7)/180*Math.PI))*this.mapR+canvas.height/2-20);
			ctx.fillText(this.scoreNumItem['idea_score'],(Math.sin((0+1*360/7)/180*Math.PI))*this.mapR+canvas.width/2+ctx.measureText(ScoreDetailItem[1]).width,-(Math.cos((0+1*360/7)/180*Math.PI))*this.mapR+canvas.height/2+21);
			ctx.fillText(this.scoreNumItem['character_score'],(Math.sin((0+2*360/7)/180*Math.PI))*this.mapR+canvas.width/2+ctx.measureText(ScoreDetailItem[2]).width-30,-(Math.cos((0+2*360/7)/180*Math.PI))*this.mapR+canvas.height/2+21);
			ctx.fillText(this.scoreNumItem['plot_score'],(Math.sin((0+3*360/7)/180*Math.PI))*this.mapR+canvas.width/2+ctx.measureText(ScoreDetailItem[3]).width/2+84,-(Math.cos((0+3*360/7)/180*Math.PI))*this.mapR+canvas.height/2+21);
			ctx.fillText(this.scoreNumItem['rule_score'],(Math.sin((0+4*360/7)/180*Math.PI))*this.mapR+canvas.width/2-20,-(Math.cos((0+4*360/7)/180*Math.PI))*this.mapR+canvas.height/2+21);
			ctx.fillText(this.scoreNumItem['transform_score'],(Math.sin((0+5*360/7)/180*Math.PI))*this.mapR+canvas.width/2-19,-(Math.cos((0+5*360/7)/180*Math.PI))*this.mapR+canvas.height/2+11);
			ctx.fillText(this.scoreNumItem['view_score'],(Math.sin((0+6*360/7)/180*Math.PI))*this.mapR+canvas.width/2-27,-(Math.cos((0+6*360/7)/180*Math.PI))*this.mapR+canvas.height/2+11);
			ctx.fill();
			ctx.closePath();

			//绘制中心评分图形
			ctx.beginPath();
			ctx.fillStyle="rgba(210,78,6,0.2)";
			ctx.strokeStyle="#D24E06";
			this.drawScoreArea(ctx,this.mapR,scoreNumArr)
			ctx.closePath();
			ctx.fill();
			ctx.stroke();

			//绘制交叉点小圆球
			this.drawSmallBall(ctx,this.mapR,scoreNumArr);
		},
		//定义绘制八边形函数
		drawFilmMap(ctx,r){
			for(let i=0;i<7;i++){
				ctx.lineTo(
					(Math.sin((i*360/7)/180*Math.PI))*r+canvas.width/2,-(Math.cos((i*360/7)/180*Math.PI))*r+canvas.height/2
				)
			}
		},
		//定义绘制中心点散发虚线函数
		drawDashLine(ctx,r){
			ctx.setLineDash([3]);
			for(let i=0;i<8;i++){
				ctx.moveTo(canvas.width/2,canvas.height/2);
				ctx.lineTo((Math.sin((i*360/7)/180*Math.PI))*r+canvas.width/2,-(Math.cos((i*360/7)/180*Math.PI))*r+canvas.height/2);
			}
		},
		//定制评分中心区域可视化分值多边形
		drawScoreArea(ctx,r,score){
			ctx.setLineDash([]);
			for(let i=0;i<8;i++){
				ctx.lineTo(
					(Math.sin((i*360/7)/180*Math.PI))*(r*(score[i]/20))+canvas.width/2,-(Math.cos((i*360/7)/180*Math.PI))*(r*(score[i]/20))+canvas.height/2
				);
			};
		},
		//交叉点圆点
		drawSmallBall(ctx,r,score){
			for(let i=0;i<8;i++){
				ctx.beginPath();
				ctx.lineWidth="1";
				ctx.strokeStyle="#D24E06";
				ctx.fillStyle="rgba(210,78,6,0.3)";
				ctx.arc(
					(Math.sin((0+i*360/7)/180*Math.PI))*(r*(score[i]/20))+canvas.width/2,-(Math.cos((0+i*360/7)/180*Math.PI))*(r*(score[i]/20))+canvas.height/2,3,0*Math.PI,2.0*Math.PI
				);
				ctx.fill();
				ctx.stroke();
			};
		},
	}
}
</script>

<style lang="scss" scoped>
.red-bold{
	font-size:24px;
	color:#B31E23;
}
.canvas-wrap{
	width:100%;
	height:700px;
	.header{
		height:40px;
		background:#fff;
		font-size:30px;
		font-weight:bold;
		padding:10px 0px 50px 0px;
		color:#222;
		.title{
			float:left;
		}
		.score{
			float:right;
			div{
				display:inline-block;
				font-size:20px;
			}
			span{
				vertical-align:middle;
			}
			.level{
				margin-right:20px;
			}
		}
	}
	.canvas-box{
		height:610px;
	}
	.to-detail{
		height:60px;
		background:#fff;
		text-align:center;
		padding-top:38px;
		span{
			display:inline-block;
			font-size:20px;
			padding:15px 80px;
			color:#fff;
			background:#282828;
		}
		span:active{
			background:#555;
		}
	}
}
</style>